import React from 'react';
import { motion } from 'framer-motion';
export function Board() {
  const boardMembers = [{
    name: 'Thomas Schoaf',
    title: 'Chairman',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: 'Former Mayor and dedicated advocate for West Valley economic development and smart zoning.'
  }, {
    name: 'Joseph Pizzillo',
    title: 'Vice Chairman',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: 'City Council leader focused on fiscal responsibility and preserving local governance.'
  }, {
    name: 'Brannon Hampton',
    title: 'Treasurer',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: 'Financial expert ensuring transparent and effective use of PAC resources for community impact.'
  }, {
    name: 'Jennifer Polansky',
    title: 'Secretary',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: 'Community organizer passionate about quality of life initiatives and neighborhood safety.'
  }, {
    name: 'Jodi Tas',
    title: 'Board Member',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: 'Long-time West Valley resident and advocate for responsible municipal growth.'
  }];
  return <section id="leadership" className="py-24 bg-pac-sand" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div className="text-center mb-16" data-id="element-4">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-5">
            Board of Directors
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-6">
            Experienced leaders committed to the future of the West Valley.
          </p>
          <div className="w-24 h-1 bg-pac-red mx-auto mt-6" data-id="element-7"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center" data-id="element-8">
          {boardMembers.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200 ${index === 3 ? 'lg:col-start-2 lg:-ml-1/2' : '' // Center the bottom row if needed, but flex wrap is better. Using grid here so we'll just let it flow.
        }`} data-id="element-9">
              <div className="aspect-w-4 aspect-h-3 h-64 overflow-hidden" data-id="element-10">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500" data-id="element-11" />
              </div>
              <div className="p-6 text-center" data-id="element-12">
                <h3 className="font-serif text-2xl font-bold text-pac-navy mb-1" data-id="element-13">
                  {member.name}
                </h3>
                <p className="text-pac-red font-bold text-sm uppercase tracking-wider mb-4" data-id="element-14">
                  {member.title}
                </p>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-15">
                  {member.bio}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}